import script from "./useServerTable.vue?vue&type=script&lang=js"
export * from "./useServerTable.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__